
import React, { useEffect, useRef, useState } from "react";
import Form, { CustomRule, EmailRule, GroupItem, Item, Label, RequiredRule } from "devextreme-react/form";
import BaseFormWithBreadCrumbs from "../../../components/base-form/base-form";
import { colCountByScreen } from "./data";
import { getPropsPhoneEditor } from "../../../utils/default-props";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { useAuth } from "../../../contexts/auth";
import { lookupGroups } from "../../../utils/lookup-groups.ts";
import UndefinedIdentity from "./undefined-identity.tsx";



function Contact({ employeeId }) {

    const formRef = useRef()
    const [formData, setFormData] = useState(
        {
            employeeId: "",
            pciAddress: "",
            pciCity: "",
            pciDistrict: "",
            pciPhoneNumber: "",
            pciGsm: "",
            pciEmail: "",
            wciPhoneNumber: "",
            wciGsm: "",
            wciEmail: "",
            wciExtensionNumber: "",
            eciName: "",
            eciSurname: "",
            eciAffinityId: "",
            eciAddress: "",
            eciPhoneNumber: "",
            eciGsm: "",
            eciEmail: "",
            id: "",
        },
    )
    const [readOnly, setReadonly] = useState(false)
    const [dirty, setDirty] = useState(false)


    const [affinityList, setAffinityList] = useState()
    const { getLookupData } = useLookupGroup()
    const { activeLanguage } = useAuth()

    const affinityOption = {
        items: affinityList,
        valueExpr: "id",
        displayExpr: "text"
    }
    const handleFieldDataChanged = (e) => {
        setDirty(true)
    }

    const handleValidationCallbackwciExtensionNumber = (e) => {
        if (!e.value)
            return true
        
        return (e.value < 10000) && (e.value > -1)
    }

    useEffect(() => {
        getLookupData(lookupGroups.affinity).then(response => setAffinityList(response))

    }, [activeLanguage])

    return (

        <React.Fragment>
            <BaseFormWithBreadCrumbs
                formRef={formRef}
                loadId={employeeId}
                formData={formData}
                setFormData={setFormData}
                readOnly={readOnly}
                setReadOnly={setReadonly}
                dirty={dirty}
                setDirty={setDirty}
                initialValues={{ employeeId: employeeId }}
                loadUrl={"/api/EmployeeContact/Employee/"}
                updateUrl={"/api/EmployeeContact/FormData"}

            >
                <Form
                    formData={formData}
                    readOnly={readOnly}
                    colCountByScreen={colCountByScreen}
                    //onFieldDataChanged={handleFieldDataChanged}
                    ref={formRef}
                    onFieldDataChanged={handleFieldDataChanged}
                >
                    <GroupItem caption="Kişisel İletişim Bilgisi">
                        <Item dataField="pciGsm" editorOptions={getPropsPhoneEditor}>
                            <RequiredRule />
                            <Label text="GSM" />
                        </Item>
                        <Item dataField="pciPhoneNumber" editorOptions={getPropsPhoneEditor}>
                            <Label text="Telefon No" />
                        </Item>
                        <Item dataField="pciEmail">
                            <EmailRule />
                            <Label text="E-Mail" />
                        </Item>
                        <Item dataField="pciCity" >
                            <Label text="Şehir" />
                        </Item>
                        <Item dataField="pciDistrict" >
                            <Label text="Semt" />
                        </Item>
                        <Item dataField="pciAddress" >
                            <Label text="Adres" />
                        </Item>
                    </GroupItem>

                    <GroupItem caption="İşyeri İletişim Bilgisi">
                        <Item dataField="wciPhoneNumber" editorOptions={getPropsPhoneEditor}>
                            <Label text="Telefon No" />
                        </Item>
                        <Item dataField="wciExtensionNumber"
                            editorType="dxNumberBox"
                            //editorOptions={{ max: 9999 }}
                        >
                            <CustomRule
                                validationCallback={handleValidationCallbackwciExtensionNumber}
                            />
                            <Label text="Dahili No" />
                        </Item>
                        <Item dataField="wciGsm" editorOptions={getPropsPhoneEditor}>
                            <Label text="GSM" />
                        </Item>
                        <Item dataField="wciEmail">
                            <EmailRule />
                            <Label text="E-Mail" />
                        </Item>
                    </GroupItem>

                    <GroupItem caption="Acil Durum İletişim Bilgisi">
                        <Item dataField="eciName">
                            <Label text="Adı" />
                        </Item>
                        <Item dataField="eciSurname">
                            <Label text="Soyadı" />
                        </Item>
                        <Item dataField="eciAffinityId" editorType="dxSelectBox" editorOptions={affinityOption} >
                            <Label text="Yakınlığı" />
                        </Item>
                        <Item dataField="eciAddress">
                            <Label text="Adresi" />
                        </Item>
                        <Item dataField="eciPhoneNumber" editorOptions={getPropsPhoneEditor}>
                            <Label text="Telefon No" />
                        </Item>
                        <Item dataField="eciGsm" editorOptions={getPropsPhoneEditor}>
                            <Label text="GSM" />
                        </Item>
                        <Item dataField="eciEmail">
                            <EmailRule />
                            <Label text="E-Mail" />
                        </Item>
                    </GroupItem>

                </Form>
            </BaseFormWithBreadCrumbs>

        </React.Fragment>


    )
}

export default Contact
